import { paths } from '@omnea-digital/extops-schema'
import { GenericQuery, GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from '@omnea-app/packages/universal/general/observability/withErrorCapture'
import { ServiceUrls } from '@omnea-app/packages/universal/general/serviceUrls'

interface Params {
  authorization: string
}

export class ExtOpsApiClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.EXTERNAL_OPERATION,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type ExtOpsRequest<T extends keyof paths, T2 extends keyof paths[T]> = GenericRequestBody<paths, T, T2>
export type ExtOpsResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
export type ExtOpsQuery<T extends keyof paths, T2 extends keyof paths[T]> = GenericQuery<paths, T, T2>
